import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ENV_CONFIG } from '@ps/core-config';
import { LOADING_CONTEXT } from '@ps/core-overlay';
import {
  DashboardPreference,
  DashboardPreferenceParams,
} from '@ps/user-settings-models';

import {
  DashboardPreferenceDto,
  DashboardPreferencesUpdateDto,
} from './dtos/dashboard-preference.dto';
import { DashboardPreferenceMapper } from './mappers/dashboard-preference.mapper';

@Injectable({
  providedIn: 'root',
})
export class DashboardApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);
  private readonly _basePreferenceUrl = `${this._env.pureSpectrum.url}/users/dashboard-preference`;
  private readonly _mapper = new DashboardPreferenceMapper();

  public getPreferences(
    params: DashboardPreferenceParams,
  ): Observable<DashboardPreference[]> {
    const httpParams = new HttpParams({ fromObject: { ...params } });
    return this._http
      .get<
        DashboardPreferenceDto[]
      >(this._basePreferenceUrl, { params: httpParams, context: new HttpContext().set(LOADING_CONTEXT, true) })
      .pipe(map((dtos) => this._mapper.fromDtoList(dtos)));
  }

  public updatePreferences(
    preferences: DashboardPreference[],
  ): Observable<DashboardPreferencesUpdateDto> {
    return this._http.post<DashboardPreferencesUpdateDto>(
      this._basePreferenceUrl,
      preferences,
    );
  }
}
